/**
 * ContentActionsSheet
 *
 * Helper function to show content actions sheet using SheetService.
 * Matches Flutter implementation: lib/presentation/bottom_sheet/content_actions_bottom_sheet.dart
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { ContentActionsContent } from './components/ContentActionsContent';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

/**
 * Show content actions sheet
 *
 * @param media - The content/media entity to show actions for
 * @param container - Optional container element, screen key string, or null
 * @param screenKey - Optional screen key of the route opening this sheet
 * @param fixedHeight - Fixed height for the sheet, from responsive.contentActionsSheet.fixedHeight
 */
const show = (
  media: UserMediaEntity,
  container?: HTMLElement | string | null,
  screenKey?: string,
  fixedHeight?: string,
) => {
  SheetService.show({
    title: '',
    content: <ContentActionsContent media={media} screenKey={screenKey} />,
    container,
    screenKey,
    fixedHeight,
  });
};

// Export the ContentActionsSheet to call as ContentActionsSheet.show(...)
export const ContentActionsSheet = {
  show,
};
